import React from 'react';
import { IconUsers, IconPin, IconCalendar } from '../ui/Icons';

export interface MapFilters {
  showUsers: boolean;
  showPins: boolean;
  showEvents: boolean;
}

interface Props {
  filters: MapFilters;
  onChange: (filters: MapFilters) => void;
}

const TOGGLES: { key: keyof MapFilters; Icon: React.FC<{ size?: number; className?: string }>; label: string }[] = [
  { key: 'showUsers',  Icon: IconUsers,    label: 'People' },
  { key: 'showPins',   Icon: IconPin,      label: 'Pins' },
  { key: 'showEvents', Icon: IconCalendar, label: 'Events' },
];

export function MapFilterToggle({ filters, onChange }: Props) {
  return (
    <div className="flex gap-1.5">
      {TOGGLES.map(t => {
        const active = filters[t.key];
        return (
          <button
            key={t.key}
            onClick={() => onChange({ ...filters, [t.key]: !active })}
            className={`flex items-center gap-1 px-2.5 py-1.5 rounded-xl text-[10px] font-semibold transition-all active:scale-95 ${
              active ? 'glass text-stabeon-text' : 'bg-stabeon-bg/60 text-stabeon-muted line-through opacity-50'
            }`}
          >
            <t.Icon size={12} />
            <span>{t.label}</span>
          </button>
        );
      })}
    </div>
  );
}
